import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TablasDinamicasConfigService } from '../../../services/database/tablas-dinamicas-config.service';
import { DocumentoDinamico, TablasDinamicasConfig } from '../../../shared/interfaces/database/tramites_automaticos';
import { ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, IHeader, LoadingPanelService, VisorComponent } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopupModule } from 'primeng/confirmpopup';

@Component({
  selector: 'app-get-dataset-documentos',
  standalone: true,  
  imports: [CustomTableComponent, VisorComponent, ConfirmPopupModule],
  providers: [ConfirmationService],
  template: `
  <p-confirmPopup></p-confirmPopup>
  <app-visor/>
  <custom-table [config]="customTable">
  </custom-table>
  `
})
export class GetDatasetDocumentosComponent implements OnInit {
  @Input() tablaDinamicaConfig!: TablasDinamicasConfig;
  @Input() filaId!: number;

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(VisorComponent) visorDialog !: VisorComponent;

  constructor(private readonly _tsc: TablasDinamicasConfigService, private readonly _lps: LoadingPanelService,
    private readonly _t: TranslateService, private readonly _cs: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.translate().then(() => {
      this.configurarTabla();
    });

    this.consultarDocumentos();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      nombre: this._t.get('common.nombre'),
      fechaCreacion: this._t.get('common.fechaCreacion'),
      estasSeguroDeQueQuieresEliminarLaDocumento: this._t.get('msg.estasSeguroDeQueQuieresEliminarLaDocumento'),
    }));
  }

  configurarTabla() {
    this.customTable = {
      header: {
      } as IHeader,
      columns: [
        {
          field: 'nombre',
          header: this.trans.nombre,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaCreacion',
          header: this.trans.fechaCreacion,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          dataType: DataColumnType.DATE
        },
        {
          field: 'download',
          header: '',
          icon: 'pi pi-download',
          class: 'p-button-outlined pt-2 pb-2 pr-1',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: DocumentoDinamico) => this.descargarDocumento(data),
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          onClick: (event: Event, data: DocumentoDinamico) => this.deleteConfirmation(event, data)
        }
      ],
      settings: {
        table: {
          rows: 10,
        }
      }
    } as ICustomTable;
  }

  descargarDocumento(data: DocumentoDinamico): void {
    this._lps.show(true);
    this._tsc.descargarDocumento(this.tablaDinamicaConfig.id, data.id).subscribe({
      next: (response: Blob) => {
        this.visorDialog.showDialog(response);
        this._lps.hide();
      }
    });
  }

  deleteConfirmation(event: Event, data: DocumentoDinamico): void {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: this.trans.estasSeguroDeQueQuieresEliminarLaDocumento,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this._lps.show(true);
        this._tsc.borrarDocumento(this.tablaDinamicaConfig.id, data.id).subscribe({
          next: () => {
            this.consultarDocumentos();
            this._lps.hide();
          }
        });
      },
      reject: () => {

      }
    });

    
  }

  consultarDocumentos() {
    this._lps.show(true);
    this._tsc.consultarDocumentos(this.tablaDinamicaConfig.id, this.filaId).subscribe({
      next: (data: DocumentoDinamico[]) => {
        this.customTableComponent.data = data;
        this._lps.hide();
      },
    });
  }

}
